import Config from 'utils/config'
import AppTools from 'utils/app/appTools'


const addUrlParameter = (query, param) => {
  if (query !== '') {
    query += '&';
  }
  return query += param;
}

const getIndicatorDataV0Facade = ({ indicator, geo, time }) => {
  let query = '';

  geo.forEach( (geo_id) => {
    query = addUrlParameter( query, `geo[${geo_id}]=${geo_id}` );
  });

  if (time !== undefined) {
    time.forEach( (time) => {
      query = addUrlParameter( query, `time=${time}` );
    });
  }

  query = addUrlParameter( query, "ignore_missing=yes" );
  query = addUrlParameter( query, "haggr_mode=any" );

  return Config.getConfig().app.urls.BASE_URL_HONTZA + `indicator/${indicator}/query?${query}`
}


const getIndicatorData = ({ indicator, geo, time, meta }) => {
  let query = '';

  geo.forEach( (geo_id) => {
    query = addUrlParameter( query, `geo=${geo_id}` );
  });

  if (time !== undefined) {
    time.forEach( (time) => {
      query = addUrlParameter( query, `time=${time}` );
    });
  }

  if ( meta === true ) {
    query = addUrlParameter( query, `meta=true` );
  }

  const lang = AppTools.getActualLanguage();
  query = addUrlParameter( query, `lang=${lang}` );

  return Config.getConfig().app.urls.BASE_URL_HONTZA_API_V1 + `indicator/${indicator}/data?${query}`
}

const API_V1_URL = {
  getIndicatorData,
  getIndicatorDataV0Facade
}

export default API_V1_URL



// WEBPACK FOOTER //
// ./src/utils/api/urls_v1.js